import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  container: {
    paddingBottom: 24,
    gap: 8,
  },
  iconContainer: {
    alignItems: 'flex-end',
    paddingHorizontal: 24,
    flex: 1,
  },
  iconClose: {
    width: 24,
    height: 24,
    padding: 5,
    color: neutrals.neutralGrays.cement,
  },
  content: {
    paddingBottom: 16,
    gap: 16,
    alignItems: 'center',
  },
  textContainer: {
    paddingHorizontal: 24,
    alignItems: 'center',
  },
  title: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 24,
    color: neutrals.black,
  },
  description: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 21,
    color: neutrals.neutralGrays.graphite,
  },
  ctaContainer: {
    paddingHorizontal: 16,
    flexDirection: 'row',
    gap: 8,
  },
});
